export const REFRESH_INTERVAL_MS = 60000; //refresh event list and details once per minute
export const WIFI_POLL_INTERVAL_MS = 2500;
export const WIFI_POLL_TIMEOUT_MS = 60000; //stop trying after 60sec
export const MAX_RECURRING_EVENTS = 100;
export const PREROLL_TIME = 10 * 60 * 1000; // 10 minutes in milliseconds

// 5 minutes -- see https://github.com/boxcast/boxcast_api/blob/master/app/models/highlight.rb for Highlight::MAX_DURATION
export const MAX_MONETIZED_HIGHLIGHT_TIME_S = 300;

export const AUDIO_ONLY_BITRATE_HINT = 10000;

export const BOXCAST_JS_ENV = 'prod';
export const BOXCAST_JS_EMBED_URL = '//js.boxcast.com/v3.min.js';
export const BOXCAST_JS_IFRAME_URL = 'https://boxcast.tv/view-embed';
export const BOXCAST_JS_APP_EMBED_URL = 'https://boxcast.tv/embed-app.html';
export const SYNDICATION_SERVICE_BASE_URL = 'https://syndication.boxcast.com';

export const GOOGLE_ANALYTICS_KEY = 'UA-15394876-6';
export const GOOGLE_ANALYTICS_DOMAIN = null;

export const YOUTUBE_SCOPE = 'https://www.googleapis.com/auth/youtube';
export const YOUTUBE_ANALYTICS_SCOPE = 'https://www.googleapis.com/auth/yt-analytics.readonly';

export const UNSPLASH_APP_ID = 'd95c25c1553e8c7e9a6177c9a6a04f6d107fda686347b65e15bd347f11810cec';

export const VIMEO_CLIENT_ID = 'e4ac1782f4cbfa854a3f90c6ee955fb641c0db37';
export const VIMEO_SCOPE = 'public private upload';

export const TWITTER_CLIENT_ID = 'aspcGbqPb6k2SVLYLfwU57JpF';

export const SPECTRUM_COLOR_PALETTE = {
  '#000000': 'Black',
  '#0496D4': 'Teal',
  '#99BFE5': 'Blue Light',
  '#648FCC': 'Blue Medium',
  '#002D73': 'Blue',
  '#0C2238': 'Navy',
  '#005F61': 'Aqua',
  '#3A7728': 'Green Light',
  '#00583D': 'Green',
  '#004438': 'Green Dark',
  '#FF3333': 'Red Light',
  '#C8141E': 'Red',
  '#990000': 'Maroon',
  '#FC4E04': 'Orange',
  '#E06F1F': 'Orange Burnt',
  '#6633CC': 'Purple Light',
  '#410F73': 'Purple',
  '#4E3227': 'Brown',
  '#9B8449': 'Gold Old',
  '#CC9933': 'Gold',
  '#969798': 'Silver',
};

export const STANDARD_COLOR_PALETTE = SPECTRUM_COLOR_PALETTE;

export const PROTECTED_CONTENT_SETTINGS_KEYS = [
  'app',
  'boxcast_viewer_promotion',
  'cryptblock',
  'customPreroll',
  'defaultVideo',
  'donateContactEmail',
  'donateMessage',
  'enterprise_last_mile_delivery',
  'geoblock',
  'hostRestrictions',
  'language',
  'podcast',
  'poster',
  'preview',
  'showCountdown',
  'showDonations',
  'website',
];

export const HUBSPOT_MEETINGS_BASE_URL = 'https://app.hubspot.com/meetings';



// WEBPACK FOOTER //
// ./app/environments/_shared.js